export default ["#3f8cf6", "#66df9a", "#f3b437"];
